module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<tr class=\"point\">\n    <td>\n        <input axis=\"x\" format=\"dd\" type=\"number\" name=\"point[")
    ; __append(escapeFn( point.index ))
    ; __append("][0]\" value=\"")
    ; __append(escapeFn( point.coordinate[0] ))
    ; __append("\" on-change=\"onCoordinatesCoordinateChange\"/>\n    </td>\n    <td>\n        <input axis=\"y\" format=\"dd\" type=\"number\" name=\"point[")
    ; __append(escapeFn( point.index ))
    ; __append("][1]\" value=\"")
    ; __append(escapeFn( point.coordinate[1] ))
    ; __append("\" on-change=\"onCoordinatesCoordinateChange\"/>\n    </td>\n</tr>")
  }
  return __output.join("");

}